import store from "@/store/store";

export default function handleShowButtons(buttons: []) {
  store.commit("chat/addButtons", buttons);
}
